"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectReportLocaleData = void 0;
var languages_1 = require("utils/helpers/languages");
var timezones_1 = require("utils/helpers/timezones");
var selectReportLocaleData = function (state) {
    var report = state.reports.selectedReport.report;
    return {
        language: (report === null || report === void 0 ? void 0 : report.language) ? (0, languages_1.getLanguageByCode)(report.language) : undefined,
        timezone: (report === null || report === void 0 ? void 0 : report.timezone) ? (0, timezones_1.getTimezoneByName)(report.timezone) : undefined
    };
};
exports.selectReportLocaleData = selectReportLocaleData;
